const ArticleTypes = {
  '0f0ea25c180346d98d35acb160bead9e': 'article',
  '08a1ecc05b494f33a3161c0b3045d42a': 'podcast',
  d8b293afef8847aa945b7a058bdaf096: 'video',
};

export default ArticleTypes;
